import { Button, Col, Flex, Row, Space, Table } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import styles from "./reportTabs.module.scss";
import CardChip from "../includes/CardChip";
import ZCard from "../../../Card/Index";
import { ExclamationCircleFilled, CheckCircleFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getOverview } from "../../../../api/reportDetails";
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  setAllOverviewData,
  setOverviewAccountDetails,
  setOverviewLoading,
} from "../../../../store/reducers/slices/overview.slice";
import DataFormatter from "../../../common/DataFormatter";
import dayjs from "dayjs";
import { bankDetailstoArray } from "../../../../utils/format";
import { NumberFormat } from "../../../../helper/NumberFormat";

import FloatingBarChart from "../../../Chart/FloatingBarChart";
import BarChartWithMultipleDatasets from "../../../Chart/BarChartWithMultipleDatasets";
import LineChart from "../../../Chart/LineChart";
import { TabsEnum } from "../../../../utils/Enum/ReportTabsEnum";
import { CURRENCY } from "../../../../utils/ConstantData";
import { CurrencyFormatWithDecimal } from "../../../../helper/CurrencyFormate";
import CustomAmountText from "../../../common/CustomAmountText";

const OverviewReport = ({ onClickTabChange = () => { } }) => {
  const {
    isLoading,
    irregularities,
    inFlowList,
    outFlowList,
    overviewData,
    tabCounts,
    bankAccountDetails,
  } = useSelector(({ overview }) => overview);
  console.log('overviewData', overviewData);

  const { reportDetails, selectedAccountId } = useSelector(
    ({ reportDetails }) => reportDetails
  );
  const dispatch = useDispatch();
  const bankAccountDetailsLength =
    Array.isArray(bankAccountDetails) && Array.isArray(bankAccountDetails[0])
      ? bankAccountDetails.length
      : 0;

  // let accCount = selectedAccountId === 'all' ? overviewData?.accountsInfo.length : 0;
  console.log("Logingggggggggggg", bankAccountDetailsLength, selectedAccountId);

  const onClickCommonRedirect = (value, tab) => {
    if (parseInt(value) > 0 && tab === "CIRCULARTRANSACTION") {
      onClickTabChange(TabsEnum.CIRCULARTRANSACTION);
    } else if (parseInt(value) > 0 && tab === "BOUNCEDCHEQUES") {
      onClickTabChange(TabsEnum.BOUNCEDCHEQUES);
    } else if (parseInt(value) > 0 && tab === "TRANSACTION") {
      onClickTabChange(TabsEnum.TRANSACTION);
    } else if (parseInt(value) > 0 && tab === "IRREGULARITIES") {
      onClickTabChange(TabsEnum.IRREGULARITIES);
    }
  };

  useEffect(() => {
    const fetchData = () => {
      let aggregate = selectedAccountId !== "all" ? false : true;
      let account_id =
        selectedAccountId !== "all"
          ? selectedAccountId
          : reportDetails?.report?.reportId;

      getOverview(account_id, aggregate)
        .then((resp) => {
          const inflow = resp.categories.find(
            (item) => item.type === "inflows"
          ) || { amount: 0, data: [] };
          const outflow = resp.categories.find(
            (item) => item.type === "outflows"
          ) || { amount: 0, data: [] };
          dispatch(
            setAllOverviewData({
              irregularities: resp.irregularities,
              isLoading: false,
              inFlowList: inflow,
              outFlowList: outflow,
              bankAccountDetails: [],
              overview: resp,
              tabCounts: resp.tabCounts,
            })
          );

          let _bankDetails =
            selectedAccountId === "all"
              ? resp?.accountsInfo.map((item) => {
                let obj = {
                  account: item,
                };
                console.log("object", item);

                return bankDetailstoArray(obj, true);
              })
              : bankDetailstoArray(resp);

          console.log(":::BANK DETAIL:::", _bankDetails);

          dispatch(setOverviewAccountDetails(_bankDetails));
        })
        .catch((error) => {
          dispatch(setOverviewLoading(false));
          console.log("error", error);
        });
    };

    if (selectedAccountId) {
      dispatch(setOverviewLoading(true));
      fetchData();
    }
  }, [dispatch, reportDetails?.report?.reportId, selectedAccountId]);
  const monthlyAverageDailyBalance = [
    {
      duration: "Jan 2020",
      cashflow: "-165814.0",
      bizCashFlow: "-165814.0",
      averageDailyBalance: "480995.11",
      deposits: "2563.0",
      withdrawals: "168377.0",
    },
    {
      duration: "Feb 2020",
      cashflow: "-799787.0",
      bizCashFlow: "-209163.0",
      averageDailyBalance: "-223075.48",
      deposits: "57919.0",
      withdrawals: "857706.0",
    },
    {
      duration: "Mar 2020",
      cashflow: "-499134.0",
      bizCashFlow: "-499134.0",
      averageDailyBalance: "-764418.31",
      deposits: "130374.0",
      withdrawals: "629508.0",
    },
    {
      duration: "Apr 2020",
      cashflow: "198285.83",
      bizCashFlow: "82604.83",
      averageDailyBalance: "-641887.42",
      deposits: "995027.83",
      withdrawals: "796742.0",
    },
    {
      duration: "May 2020",
      cashflow: "437631.0",
      bizCashFlow: "272631.0",
      averageDailyBalance: "-437302.36",
      deposits: "521580.0",
      withdrawals: "83949.0",
    },
    {
      duration: "Jun 2020",
      cashflow: "-81544.0",
      bizCashFlow: "-33149.0",
      averageDailyBalance: "-221624.5",
      deposits: "19274.0",
      withdrawals: "100818.0",
    },
    {
      duration: "Jul 2020",
      cashflow: "541827.0",
      bizCashFlow: "45420.0",
      averageDailyBalance: "-204442.68",
      deposits: "750000.0",
      withdrawals: "208173.0",
    },
    {
      duration: "Aug 2020",
      cashflow: "-16884.0",
      bizCashFlow: "12237.0",
      averageDailyBalance: "278540.39",
      deposits: "19660.0",
      withdrawals: "36544.0",
    },
    {
      duration: "Sep 2020",
      cashflow: "-116652.0",
      bizCashFlow: "-75341.0",
      averageDailyBalance: "216110.9",
      deposits: "41367.0",
      withdrawals: "158019.0",
    },
    {
      duration: "Oct 2020",
      cashflow: "577683.7",
      bizCashFlow: "244668.7",
      averageDailyBalance: "581764.34",
      deposits: "734008.0",
      withdrawals: "156324.3",
    },
    {
      duration: "Nov 2020",
      cashflow: "-19152.0",
      bizCashFlow: "-19152.0",
      averageDailyBalance: "703825.37",
      deposits: "0.0",
      withdrawals: "19152.0",
    },
    {
      duration: "Dec 2020",
      cashflow: "888829.0",
      bizCashFlow: "83829.0",
      averageDailyBalance: "1265171.57",
      deposits: "997239.0",
      withdrawals: "108410.0",
    },
  ];

  const onClickIrregularity = () => {
    onClickTabChange(TabsEnum.IRREGULARITIES);
  };

  const bankDetails = useMemo(() => {
    if (overviewData && Object.keys(overviewData).length > 0) {
      if (selectedAccountId === "all") {
        let newList = bankAccountDetails;

        return newList;
      } else {
        let newList = bankDetailstoArray(overviewData);

        console.log(
          "LAST 3 MONTHS",
          overviewData.maxAmountDetail.last3MonthCredit
        );

        if (
          overviewData.maxAmountDetail &&
          overviewData.maxAmountDetail.last12MonthKey
        ) {
          let newObj12Debit = {
            label: overviewData.maxAmountDetail.last12MonthKey.replace(
              "Months",
              "Months Max Debit Amount"
            ),
            value: overviewData.maxAmountDetail.last12MonthDebit || "-",
          };
          let newObj12Credi = {
            label: overviewData.maxAmountDetail.last12MonthKey.replace(
              "Months",
              "Months Max Credit Amount"
            ),
            value: overviewData.maxAmountDetail.last12MonthCrebit || "-",
          };
          let newObj3Debit = {
            label: overviewData.maxAmountDetail.last3MonthKey.replace(
              "Months",
              "Months Max Debit Amount"
            ),
            value: CurrencyFormatWithDecimal(overviewData.maxAmountDetail.last3MonthDebit, null) || "-",
          };
          let newObj3Credi = {
            label: overviewData.maxAmountDetail.last3MonthKey.replace(
              "Months",
              "Months Max Credit Amount"
            ),
            value: CurrencyFormatWithDecimal(overviewData.maxAmountDetail.last3MonthCredit, null) || "-",
          };
          let cashDepositAbove9LakhObj = {
            label: "Cash Deposits in range (9-10)L",
            value:
              overviewData?.account?.highCashDeposits[1]
                .cashDepositAbove9Lakh || "-",
          };
          let cashDepositAbove40KLakhObj = {
            label: "Cash Deposits in range (40-50)k",
            value:
              overviewData?.account?.highCashDeposits[2].cashDepositAbove40K ||
              "-",
          };
          let atmWithdrawalAbove2KObj = {
            label: "ATM Withdrawals above ₹2,000",
            value:
              overviewData?.account?.highCashDeposits[0].atmWithdrawalAbove2K ||
              "-",
          };

          newList.push(newObj12Debit);
          newList.push(newObj12Credi);
          newList.push(newObj3Debit);
          newList.push(newObj3Credi);
          newList.push(cashDepositAbove9LakhObj);
          newList.push(cashDepositAbove40KLakhObj);
          newList.push(atmWithdrawalAbove2KObj);
        }
        return newList;
      }
    }
    return [];
  }, [overviewData]);

  const aggregateCol = useMemo(() => {
    const baseColumns = [
      {
        title: "RowHead",
        key: "label",
        dataIndex: "label",
        className: "table-column-1 w-50",
      },
    ];

    // Dynamically generate columns for each account
    bankAccountDetails?.forEach((_, index) => {
      console.log("INDEX >>>>", `Account ${index + 1}`);

      baseColumns.push({
        title: `Account ${index + 1}`, // Change title as per requirement
        key: `account_${index + 1}`,
        dataIndex: `account_${index + 1}`,
        className: `table-column-${index + 2} w-50`,
      });
    });

    return baseColumns;
  }, [bankAccountDetails]);

  const dataSource = useMemo(() => {
    if (bankAccountDetails && bankAccountDetails.length === 0) return [];

    console.log(
      "FLEXIBLE ARRAY :::: ::::::: >>>>",
      bankAccountDetails,
      selectedAccountId
    );
    let flexArray =
      selectedAccountId === "all"
        ? bankAccountDetails || [[]]
        : bankAccountDetails
          ? [[...bankAccountDetails]]
          : [[]] || [[]];
    console.log("FLEXIBLE ARRAY :::: ::::::: >>>>", flexArray);

    const labels = flexArray[0].map((item) => item.label); // Extract common labels [[]]

    const labelAndvalue = labels.map((label) => {
      const rowData = { label }; // Start with the label

      // Add values from each account for this label
      flexArray.forEach((account, index) => {
        const matchingItem = account.find((item) => item.label === label);
        rowData[`account_${index + 1}`] = matchingItem
          ? matchingItem.value
          : "-"; // Add account value or default '-'
      });

      return rowData;
    });

    let merger = [];

    if (selectedAccountId === "all") {
      // Helper function to dynamically create account fields
      const createAccountFields = (keyPath, label) => {
        const accounts = overviewData?.accountsInfo || [];
        const accountObj = { label: label };

        accounts.forEach((account, index) => {
          const accountKey = `account_${index + 1}`;
          accountObj[accountKey] = keyPath(account) || "-";
        });

        return accountObj;
      };

      // Objects with dynamic account fields based on the number of accounts
      let newObj12Debitmodified = createAccountFields(
        (account) => account?.maxAmountDetail?.last12MonthDebit,
        overviewData?.accountsInfo[0]?.maxAmountDetail?.last12MonthKey.replace(
          "Months",
          "Months Max Debit Amount"
        )
      );

      let newObj12Credit = createAccountFields(
        (account) => account?.maxAmountDetail?.last12MonthCredit,
        overviewData?.accountsInfo[0]?.maxAmountDetail?.last12MonthKey.replace(
          "Months",
          "Months Max Credit Amount"
        )
      );

      let newObj3Debitmodified = createAccountFields(
        (account) => account?.maxAmountDetail?.last3MonthDebit,
        overviewData?.accountsInfo[0]?.maxAmountDetail?.last3MonthKey.replace(
          "Months",
          "Months Max Debit Amount"
        )
      );

      let newObj3Credit = createAccountFields(
        (account) => account?.maxAmountDetail?.last3MonthCredit,
        overviewData?.accountsInfo[0]?.maxAmountDetail?.last3MonthKey.replace(
          "Months",
          "Months Max Credit Amount"
        )
      );

      let cashDepositAbove9LakhObj = createAccountFields(
        (account) => account?.highCashDeposits[1]?.cashDepositAbove9Lakh,
        "Cash Deposits in range (9-10)L"
      );

      let cashDepositAbove40KLakhObj = createAccountFields(
        (account) => account?.highCashDeposits[2]?.cashDepositAbove40K,
        "Cash Deposits in range (40-50)k"
      );

      let atmWithdrawalAbove2KObj = createAccountFields(
        (account) => account?.highCashDeposits[0]?.atmWithdrawalAbove2K,
        "ATM Withdrawals above ₹2,000"
      );

      merger.push(newObj12Debitmodified);
      merger.push(newObj12Credit);
      merger.push(newObj3Debitmodified);
      merger.push(newObj3Credit);
      merger.push(cashDepositAbove9LakhObj);
      merger.push(cashDepositAbove40KLakhObj);
      merger.push(atmWithdrawalAbove2KObj);
    }

    const finalArray =
      selectedAccountId === "all"
        ? [...labelAndvalue, ...merger]
        : labelAndvalue;

    return finalArray;
  }, [bankAccountDetails, selectedAccountId]);

  console.log("DATA SOURCE", dataSource);

  return (
    <>
      <Flex justify="space-between" style={{ marginBottom: "16px" }}>
        <CardChip
          // label={`Zentra Score`}
          label={
            <>
              Zentra Score
              <Tooltip title={"Zentra score denotes overall creditworthiness of the entity under review. This score is computed by Precisa’s proprietary algorithm based on various signals like irregular activities, OD/CC utilization, volatility, etc. Computed score could range from 0-1000 where 1000 means \"No risk\" and 0-499 means \"Moderate to High Risk\""}>
                <QuestionCircleOutlined style={{ marginLeft: 8, fontSize: '14px', color: '#666666' }} />
              </Tooltip>
            </>
          }
          value={overviewData?.precisaScore || "-"}
        />
        <CardChip
          // label={`Volatility Score`}
          label={
            <>
              Volatility Score
              <Tooltip title="Volatility score denotes the stability of inflow, outflow activities taking place in the account. Score ranges from 0-1 where 0 means account is very stable with consistent inflows and outflows. A score of 1 on the other hand means there are too many and inconsistent inflows and outflows i.e. the account fluctuates a lot.">
                <QuestionCircleOutlined style={{ marginLeft: 8, fontSize: '14px', color: '#666666' }} />
              </Tooltip>
            </>
          }
          value={overviewData?.volatilityScore || "-"}
        />
        <CardChip label={
          <>
            FOIR
            <Tooltip title="FOIR or the Fixed Obligations to Income Ratio is used to gauge a salaried borrower’s loan eligibility. It represents the portion of monthly income that is earmarked for repaying existing loans. It is calculated by dividing monthly loan repayments by salary, and averaging it for the bank statement period. Typically FOIR of 55% or below of below is considered low risk.">
              <QuestionCircleOutlined style={{ marginLeft: 8, fontSize: '14px', color: '#666666' }} />
            </Tooltip>
          </>
        } value={overviewData?.foirScore || "-"} />
        {selectedAccountId === "all" ? (
          <CardChip
            label={`Irregularities`}
            value={overviewData?.tabCounts?.irregularitiesCount || 0}
            onClick={() =>
              onClickCommonRedirect(
                overviewData?.tabCounts?.irregularitiesCount,
                "IRREGULARITIES"
              )
            }
          />
        ) : (
          ""
        )}
        <CardChip
          label={`Circular Transactions`}
          value={overviewData?.tabCounts?.circularTransactionCount || 0}
          onClick={() =>
            onClickCommonRedirect(
              overviewData?.tabCounts?.circularTransactionCount,
              "CIRCULARTRANSACTION"
            )
          }
        />
        <CardChip
          label={`Bounced Cheques`}
          value={overviewData?.tabCounts?.bouncedChequeCount || 0}
          onClick={() =>
            onClickCommonRedirect(
              overviewData?.tabCounts?.bouncedChequeCount,
              "BOUNCEDCHEQUES"
            )
          }
        />
        <CardChip
          label={
            selectedAccountId === "all"
              ? `Total Txn - ${overviewData.aggAccStartDate && overviewData.aggAccEndDate
                ? `${dayjs(overviewData.aggAccStartDate).format(
                  "DD/MM/YYYY"
                )} - ${dayjs(overviewData.aggAccEndDate).format(
                  "DD/MM/YYYY"
                )}`
                : ""
              }`
              : `Txn - ${overviewData.txnStartDate && overviewData.txnEndDate
                ? `${dayjs(overviewData.txnStartDate).format(
                  "DD/MM/YYYY"
                )} - ${dayjs(overviewData.txnEndDate).format(
                  "DD/MM/YYYY"
                )}`
                : ""
              }`
          }
          value={
            selectedAccountId === "all"
              ? overviewData?.aggAccTxnCount || "-"
              : overviewData?.transactionCount || "-"
          }
        />
        {selectedAccountId !== "all" && (
          <CardChip
            label={`Monthly Avg. Balance`}
            value={NumberFormat(
              overviewData.averageDailyBalance || "",
              true,
              CURRENCY
            )}
          />
        )}
      </Flex>
      <Row gutter={[16, 16]}>
        {selectedAccountId === "all" ? (
          <Col>
            <ZCard>
              <ZCard.Title level={5} className={`${styles.zCardTitle} pl-16`}>
                Bank Account Details
              </ZCard.Title>
              <Table
                columns={aggregateCol}
                showHeader={false}
                loading={isLoading}
                dataSource={dataSource}
                pagination={false}
                scroll={{
                  y: 425,
                }}
              />
            </ZCard>
          </Col>
        ) : (
          <Col lg={12}>
            <ZCard>
              <ZCard.Title level={5} className={`${styles.zCardTitle} pl-16`}>
                Bank Account Details
              </ZCard.Title>
              <Table
                columns={[
                  {
                    title: "RowHead",
                    key: "1",
                    dataIndex: "label",
                    className: "table-column-1 w-50",
                  },
                  {
                    title: "RowHead",
                    key: "2",
                    dataIndex: "value",
                    className: "table-column-2 w-50",
                  },
                ]}
                showHeader={false}
                loading={isLoading}
                dataSource={bankDetails}
                pagination={false}
                scroll={{
                  y: 425,
                }}
              />
            </ZCard>
          </Col>
        )}
        <Col lg={12}>
          <ZCard>
            <ZCard.Title level={5} className={`${styles.zCardTitle} pl-16`}>
              Irregularities ({tabCounts?.irregularitiesCount || 0})
            </ZCard.Title>
            <Table
              columns={[
                {
                  title: "Activity",
                  key: "1",
                  dataIndex: "activity",
                  className: "table-column-1 w-75",
                  render: (text, record, index) => {
                    if (text === "Balance Mismatch") {
                      return "Balance vs Computed balance mismatch"
                    } else if (text === "Negative Balance") {
                      return "Negative computed balance in DR txns"
                    } else {
                      return text
                    }
                  }
                },
                {
                  title: "Incidences",
                  key: "2",
                  dataIndex: "incidences",
                  className: "table-column-2 w-25",
                  align: "right",
                  render: (text, record, index) => {
                    if (text !== "0") {
                      return (
                        <Space key={index}>
                          <Button
                            type="link"
                            onClick={onClickIrregularity}
                            className="px-0"
                          >
                            {text}
                          </Button>{" "}
                          <ExclamationCircleFilled
                            className="icon-error"
                            style={{ fontSize: 20 }}
                          />
                        </Space>
                      );
                    } else {
                      return (
                        <Space key={index}>
                          {text}{" "}
                          <CheckCircleFilled
                            className="icon-success"
                            style={{ fontSize: 20 }}
                          />
                        </Space>
                      );
                    }
                  },
                },
              ]}
              loading={isLoading}
              dataSource={irregularities}
              pagination={false}
              scroll={{
                y: 370,
              }}
            />
          </ZCard>
        </Col>
        {/* CHART */}
        <Col lg={12}>
          <ZCard loading={isLoading}>
            <Flex className="pl-16 pb-9" justify="space-between">
              <ZCard.Title level={5} className={`${styles.zCardTitle} mb-0`}>
                {selectedAccountId === "all"
                  ? `Monthly avg balance (${CURRENCY}) - ${bankAccountDetailsLength} Bank Accounts`
                  : `Monthly avg balance (${CURRENCY})`}
              </ZCard.Title>
            </Flex>
            <FloatingBarChart
              tooltipType="currency"
              dataArray={overviewData?.monthlyAverageDailyBalance || []}
            />
          </ZCard>
        </Col>
        {/* CHART */}
        {selectedAccountId !== "all" && (
          <>
            <Col lg={12}>
              <ZCard loading={isLoading}>
                <Flex className="pl-16" justify="space-between">
                  <ZCard.Title level={5} className={`${styles.zCardTitle}`}>
                    Deposits & Withdrawals ({CURRENCY})
                  </ZCard.Title>
                </Flex>
                <BarChartWithMultipleDatasets
                  dataArray={overviewData?.monthlyAverageDailyBalance || []}
                  xKey="duration"
                  yKeys={["deposits", "withdrawals"]}
                  labels={["Deposits", "Withdrawals"]}
                  bgcolors={["rgba(88, 80, 236, 1)", "rgba(242, 160, 8, 1)"]}
                  borderColors={[
                    "rgba(54, 162, 235, 1)",
                    "rgba(255, 99, 132, 1)",
                  ]}
                  horizontalLines={7} // Set the number of horizontal lines
                  yLableRoatation={30}
                  tooltipType="currency"
                  showlegendTitle={false}
                />
              </ZCard>
            </Col>
          </>
        )}
        {/* CHART */}
        <Col lg={12}>
          <ZCard loading={isLoading}>
            <Flex className="pl-16 pb-9" justify="space-between">
              <ZCard.Title level={5} className={`${styles.zCardTitle}`}>
                {selectedAccountId === "all"
                  ? `Net cash flow (${CURRENCY}) - ${bankAccountDetailsLength} Bank Accounts`
                  : `Net cash flow (${CURRENCY})`}
              </ZCard.Title>
            </Flex>
            <LineChart
              dataArray={overviewData?.monthlyAverageDailyBalance || []}
              xKey="duration"
              yKeys={["cashflow", "bizCashFlow"]}
              labels={["Net cash flow", "Net biz cash flow"]}
              bgcolors={["rgba(88, 80, 236, 1)", "rgba(242, 160, 8, 1)"]}
              borderColors={["rgba(88, 80, 236, 1)", "rgba(255, 159, 64, 1)"]}
              pointbgColors={["rgba(88, 80, 236, 1)", "rgba(255, 159, 64, 1)"]}
              tooltipType="currency"
              legendPosition="bottom"
              showLegendTitle={false}
            />
          </ZCard>
        </Col>
        <Col lg={12}>
          <ZCard>
            <Flex className="pl-16" justify="space-between">
              <ZCard.Title level={5} className={`${styles.zCardTitle}`}>
                {selectedAccountId === "all"
                  ? `Outflow - ${bankAccountDetailsLength} Bank Accounts`
                  : `Outflow`}
              </ZCard.Title>
              <ZCard.Title level={5} className={`${styles.zCardTitle}`}>
                {CURRENCY}
                {<CustomAmountText value={outFlowList?.amount} /> || 0}
              </ZCard.Title>
            </Flex>
            <Table
              columns={[
                {
                  title: "Category",
                  key: "1",
                  dataIndex: "category",
                  className: "table-column-1 w-50",
                },
                {
                  title: `Amount (${CURRENCY})`,
                  key: "2",
                  dataIndex: "amount",
                  className: "table-column-2 w-50",
                  align: "right",
                  render: (value) =>
                    CurrencyFormatWithDecimal(value || "", null, CURRENCY),
                },
              ]}
              loading={isLoading}
              dataSource={outFlowList?.data || []}
              pagination={false}
              scroll={{
                y: 230,
              }}
            />
          </ZCard>
        </Col>
        <Col lg={12}>
          <ZCard>
            <Flex className="pl-16" justify="space-between">
              <ZCard.Title level={5} className={`${styles.zCardTitle}`}>
                {selectedAccountId === "all"
                  ? `Inflow - ${bankAccountDetailsLength} Bank Accounts`
                  : `Inflow`}
              </ZCard.Title>
              <ZCard.Title level={5} className={`${styles.zCardTitle}`}>
                {CURRENCY}
                {<CustomAmountText value={inFlowList?.amount} /> || 0}
              </ZCard.Title>
            </Flex>
            <Table
              columns={[
                {
                  title: "Category",
                  key: "1",
                  dataIndex: "category",
                  className: "table-column-1 w-50",
                },
                {
                  title: `Amount (${CURRENCY})`,
                  key: "2",
                  dataIndex: "amount",
                  className: "table-column-2 w-50",
                  align: "right",
                  render: (value) => <CustomAmountText value={value} />,
                },
              ]}
              loading={isLoading}
              dataSource={inFlowList?.data || []}
              pagination={false}
            />
          </ZCard>
        </Col>
      </Row>
    </>
  );
};

export default OverviewReport;
